var __TEMP__ = require('./_baseCreate.js');var baseCreate = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseLodash.js');var baseLodash = __REQUIRE_DEFAULT__(__TEMP__);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = LazyWrapper;
